/* eslint-disable react/prop-types */ // TODO: add props
import { useState } from 'react';
import { Container, Collapse, Icon } from 'edrolo-style-guide';
import style from './styles.scss';
import { useAnalytics } from 'edrolo/analytics';

const TeachingGuide = ({ chunk }) => {
  const [open, setOpen] = useState(false);
  const { track } = useAnalytics();

  function handleClick() {
    track(`${!open ? 'opened' : 'closed'} teaching guide`);
    setOpen(!open);
  }

  if (!chunk.get('teaching_guide')) {
    return null;
  }

  return (
    <section className={style.teachingGuide}>
      <Container>
        <Collapse isOpen={open}>
          <Collapse.Header onClick={() => handleClick()}>
            <header className={style.header}>
              <Icon
                name={open ? 'arrow-dropdown' : 'arrow-dropright'}
                size="large"
                color="blue"
              />
              Teaching Guide
            </header>
          </Collapse.Header>
          <Collapse.Body>
            <div
              id="teaching-guide"
              className={style.body}
              dangerouslySetInnerHTML={{ __html: chunk.get('teaching_guide') }}
              data-test="teaching-guide-contents"
            />
          </Collapse.Body>
        </Collapse>
      </Container>
    </section>
  );
};

export default TeachingGuide;
